import { register } from '../../../JavaScript/Utils'

const HubSpotForm = el => {
  const formContainer = el.querySelector(`#hubspot-form-${el.dataset.formId}`)
  const hbspt = window.hbspt

  hbspt.forms.create({
    target: `#hubspot-form-${el.dataset.formId}`,
    region: el.dataset.region,
    portalId: el.dataset.portalId,
    formId: el.dataset.formId,
    onFormReady: form => {
      const setFrameHeight = () => {
        const formFrame = formContainer.querySelector('.hs-form-iframe')
        const frameHeight = formFrame.contentDocument.body.offsetHeight
        formFrame.style.height = `${frameHeight}px`
      }

      // Since the onFormReady from hbspt is not working correctly, this is needed
      // Also a combination of onFormReady and window.load Event does not work
      window.setTimeout(setFrameHeight, 1000)
    }
  })
}

register('HubSpotForm', HubSpotForm)
